var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFire1 = function SvgIconFire1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C2A2FF",
    filter: "url(#icon_fire1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.178 4h2.807v16.842h-2.807zM34.178 50.316h2.807v16.842h-2.807zM34.178 67.158h2.807V84h-2.807zM67.159 34.176v2.807H50.317v-2.807zM20.843 34.175v2.807H4v-2.807zM58.9 56.916l-1.984 1.985-11.91-11.91 1.986-1.984zM26.15 24.166l-1.984 1.985-11.91-11.91 1.986-1.984zM56.916 12.256l1.985 1.985L46.992 26.15l-1.985-1.985zM24.166 45.007l1.985 1.985L14.242 58.9l-1.985-1.985z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_fire1_svg__a",
    width: 71.159,
    height: 88,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.760784 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_272_76083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_272_76083",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_272_76083",
    stdDeviation: 2
  })))));
};
export default SvgIconFire1;